import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ClientRedirect({ to, replace = true }) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, { replace });
  }, [navigate, to, replace]);

  return null;
}
